import React, { useCallback, useEffect, useState } from "react";

import { useHistory } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "react-bootstrap";
import toast from "react-hot-toast";
import TopBox from "../../components/TopBox";
import useRedirect from "../../hooks/Redirect";
import { axiosInstance } from "../../api/axiosDefaults";
import InfoCreate from "./info/InfoCreate";
import { useCurrentUser } from "../../contexts/CurrentUserContext";
import EpisodeList from "./EpisodeList";

import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";

export default function EpisodeCreateForm() {
  useRedirect();
  const history = useHistory();
  const currentUser = useCurrentUser();
  const queryString = window.location.search;
  const qp = new URLSearchParams(queryString);
  // Retrieve the "episode" parameter
  const nextPage = qp.get("nextPage");
  // eslint-disable-next-line
  const [errors, setErrors] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [episodes, setEpisodes] = useState([]);

  const [postData, setPostData] = useState({
    number: "",
    title: "",
  });

  const { number, title } = postData;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // const formData = new FormData();

    // Validate role
    if (!number || !/^\d+$/.test(number)) {
      toast.error("An Episode Number Must be Added", {
        duration: 2500,
        position: "top-right",
      });
      return;
    }

    // formData.append("number", number);
    const body = {
      episode_number: number,
      title: title,
      // series: params?.seriesId,
    };

    try {
      const response = await axiosInstance.post(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );
      if (response?.success === false) {
        throw response.error;
      }

      setPostData({ ...postData, number: "", title: "" });
      fetchEpisodes();
      toast.success(`Episode Created Successfully!`);
    } catch (err) {
      console.log(err);
      const backendError =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to create Episode. Try again";
      toast.error(backendError);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data || { detail: [backendError] });
      }
    }
  };

  // no longer being used
  const handleEpisodeDelete = async (episodeId) => {
    try {
      await axiosInstance.delete(
        `${localStorage.getItem("projectSlug")}/scene_episodes/${episodeId}/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      toast.success("Episode Deleted Successfully");
      fetchEpisodes();
      // setSeries(data.results);
    } catch (error) {
      toast.error("Failed to delete episode!");
    }
  };

  const buttons = (
    <div className={`text-center mb-3 pb-2 ${styles.White}`}>
      <Button
        className={`mr-3 px-3 px-md-5 ${btnStyles.Button} ${btnStyles.Shed}`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      {currentUser?.groups[0]?.name !== "Crew" && (
        <Button
          className={`ml-3 px-3 px-md-5 ${btnStyles.Button} ${btnStyles.Shed}`}
          type="submit"
        >
          Create
        </Button>
      )}
    </div>
  );

  const fetchEpisodes = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${localStorage.getItem("projectSlug")}/scene_episodes/`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );

      setEpisodes(data.results);
      // setProjectId(data.project);
    } catch (error) {
      console.log("fetch series error: ", error);
    }
  };

  useEffect(() => {
    fetchEpisodes();
  }, []);

  const getLink = useCallback(
    (episode) => {
      // Add null/undefined check for episode
      if (!episode) return "/";

      if (nextPage === "scenesPage") {
        return `/${localStorage.getItem("projectSlug")}/scenes?episode=${episode.id
          }&project=${episode.project}&episodeTitle=${encodeURIComponent(
            episode.episode_number
          )}`;
      } else if (nextPage === "days") {
        return `/${localStorage.getItem("projectSlug")}/days?episode=${episode.id
          }&project=${episode.project}&episodeTitle=${encodeURIComponent(
            episode.episode_number
          )}`;
      } else if (nextPage === "callsheets") {
        return `/${localStorage.getItem("projectSlug")}/callsheets?episode=${episode.id
          }&project=${episode.project}&episodeTitle=${encodeURIComponent(
            episode.episode_number
          )}`;
      } else if (nextPage === "findposts") {
        return `/${localStorage.getItem(
          "projectSlug"
        )}/findposts/departments?episode=${episode.id}&project=${episode.project
          }&episodeTitle=${encodeURIComponent(episode.episode_number)}`;
      } else {
        return `/${localStorage.getItem("projectSlug")}/scenes`;
      }
    },
    [nextPage]
  );

  return (
    <div>
      <TopBox title="Episodes" />
      <Row>
        {/* back bit */}
        <Col xs={4}>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-2`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
        {/* info but */}
        <Col className="float-right" xs={8}>
          <Button
            className={`float-right py-0 my-2 ${btnStyles.Order} ${btnStyles.Button}`}
            onClick={() => setShowInfo((showInfo) => !showInfo)}
          >
            INFO
          </Button>
        </Col>
      </Row>
      {/* showInfo */}
      <Row>
        <Col>{!showInfo ? "" : <InfoCreate />}</Col>
      </Row>
      {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (
        <>
          <h5 className={`text-center py-1 mt-3 ${styles.SubTitle }`}>
           CREATE EPISODES</h5> 
          <Form className={`mb-3 ${styles.Back}`} onSubmit={handleSubmit}>
            <Row className="text-center">
              <Col
                className="d-flex justify-content-center p-0 p-md-2"
                xs={6}
              >
                <Form.Group controlId="number" className={`${styles.Width2} `}>
                  <Form.Label className={`${styles.BoldScene}`}>
                    Episode Number
                  </Form.Label>
                  <Form.Control
                    className={styles.Input}
                    type="text"
                    name="number"
                    value={number}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.number?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col
                className="d-flex justify-content-center p-0 p-md-2"
                xs={6}
              >
                <Form.Group controlId="title" className={`${styles.Width2} `}>
                  <Form.Label className={`${styles.BoldScene}`}>Title</Form.Label>
                  <Form.Control
                    className={styles.Input}
                    type="text"
                    name="title"
                    value={title}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.title?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <div className={`mt-3 ${styles.Container}`}>{buttons}</div>
              </Col>
            </Row>
          </Form>
          <Row>
          <Col xs={{span: 8, offset: 2}} >
          <hr className="mt-0 mb-0"/>
          </Col>
          </Row>
        </>
      )}
      <h3 className="text-center my-3">Select Episode</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      <EpisodeList
        episodes={episodes}
        currentUser={currentUser}
        handleEpisodeDelete={handleEpisodeDelete}
        getLink={getLink}
      />
    </div>
  );
}
